import queryString from 'query-string'

export const deleteQueryParam = (
  key: string,
  { search = window.location.search, replace = false } = {}
): void => {
  if (!key) {
    return
  }

  const searchParams = queryString.parse(search)

  if (!searchParams[key]) {
    return
  }

  delete searchParams[key]

  const urlState = queryString.stringify(searchParams)

  if (replace) {
    window.history.replaceState({ turbolinks: true }, '', '?' + urlState)
  } else {
    window.history.pushState({ turbolinks: true }, '', '?' + urlState)
  }
}

export const getQueryParam = (
  key: string,
  search: string = window.location.search
): string | (string | null)[] | null => {
  const searchParams = queryString.parse(search)

  return searchParams[key]
}

export const getQueryParamId = (
  key: string,
  search: string = window.location.search
): number | (number | null)[] | null => {
  const value = getQueryParam(key, search)

  if (Array.isArray(value)) {
    return value.map((v: string | null) => (v ? parseInt(v) : null))
  }

  return value ? parseInt(value) : null
}

export const hasQueryParam = (
  key: string,
  search: string = window.location.search
): boolean => {
  const searchParams = queryString.parse(search)

  return Boolean(searchParams[key])
}

export const setQueryParam = (
  key: string,
  value: string,
  { search = window.location.search, replace = false } = {}
): void => {
  const searchParams = queryString.parse(search)
  const urlState = queryString.stringify({ ...searchParams, [key]: value })

  if (replace) {
    window.history.replaceState({ turbolinks: true }, '', '?' + urlState)
  } else {
    window.history.pushState({ turbolinks: true }, '', '?' + urlState)
  }
}

export const setQueryParams = <KV extends Record<string, unknown>>(
  keyValuePairs: KV,
  search = window.location.search
): void => {
  const searchParams = queryString.parse(search)
  const urlState = queryString.stringify({ ...searchParams, ...keyValuePairs })

  window.history.pushState({ turbolinks: true }, '', '?' + urlState)
}
